// redux/sidebarSlice.js
import { createSlice } from '@reduxjs/toolkit';

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState: {
    selectedOption: 'Text', // Default selection
    showRecentSearches: true, // Flag to control visibility of recent searches
  },
  reducers: {
    updateSidebarSelection(state, action) {
      state.selectedOption = action.payload;
      state.showRecentSearches = action.payload === 'Text'; // Show recent searches only for text
    },
  },
});

export const { updateSidebarSelection } = sidebarSlice.actions;
export default sidebarSlice.reducer;